var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import paper from 'paper';
var Collision = /** @class */ (function (_super) {
    __extends(Collision, _super);
    function Collision(params) {
        var _this = _super.call(this, params) || this;
        _this.neuralaType = 'Collision';
        _this.closed = true;
        _this.fullySelected = false;
        _this.locked = true;
        _this.strokeWidth = 3;
        _this.strokeColor = new paper.Color('rgba(0, 0, 255, 1)');
        _this.fillColor = new paper.Color('rgba(0, 0, 255, 0.4)');
        _this.strokeScaling = false;
        return _this;
    }
    return Collision;
}(paper.CompoundPath));
export { Collision };
//# sourceMappingURL=collision.js.map


// WEBPACK FOOTER //
// ./src/components/workspace/objects/collision.ts.pre-build-optimizer.js